import { Box, ComposableTypography, ComposedElement } from '@bcp-nextgen-dx-component-factory/design-system';
import { Industry, NavClose } from '@bcp-nextgen-dx-component-factory/icons-accolade';
import { UIHelper } from '@helpers';
import { useTranslation } from '@hooks';

interface DrawerHeaderProps {
	onCloseClick?: () => void;
}

export const DrawerHeader = ({ onCloseClick }: DrawerHeaderProps) => {
	const { t } = useTranslation();

	return (
		<Box
			sx={{
				alignItems: 'center',
				p: UIHelper.rem(0, 32, 40),
				gap: UIHelper.rem(16),
			}}
		>
			<ComposedElement
				size="small"
				icon={{ source: Industry.Fill }}
				sx={{
					fill: '#D1005D',
					border: '1px solid #EFF0F5',
					borderRadius: '50%',
				}}
			/>

			<ComposableTypography
				baseProps={{
					appearance: 'subtitle-100-04',
				}}
				text={t('drawers.cookiesPreferences.title')}
				tags={{}}
			/>
			<Box
				accessibility={{ accessibilityRole: 'button' }}
				onPress={onCloseClick}
				styles={{
					cursor: 'pointer',
					marginLeft: 'auto',
				}}
			>
				<ComposedElement size="small" icon={{ source: NavClose.Outline }} fill="color_01.400" />
			</Box>
		</Box>
	);
};
